<template>
<div class="chapter">
<div class="inner_page">
<h2 class="abre">ABBREVIATIONS</h2>
<table class="table10">
<colgroup>
<col class="a30"/>
<col class="a70"/>
</colgroup>
<tbody>
<tr>
<td class="td1"><p class="tpara"><span class="bold">AMPRONAC</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Asociación de Mujeres ante la Problemática Nacional</em> (Association of Women Confronting the National Problem)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">BECAT</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Brigadas Especiales Contra Actos Terroristas</em> (Special Squads Against Terrorist Acts)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">CIA</span></p></td>
<td class="td1"><p class="tpara">Central Intelligence Agency, United States</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">COIN</span></p></td>
<td class="td1"><p class="tpara">counter-insurgent or counter-insurgency</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">CONDECA</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Consejo de Defensa Centroamericana</em> (Central American Defense Council)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">EDSN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Ejercito Defensor de la Soberania Nacional</em></p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">EEBI</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Escuela Entrenamiento Básico De Infantería</em> (Infantry Basic Training School)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">FAL</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Fusil Automatique Léger</em> (light automatic rifle, Belgian-designed firearm)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><em class="italic">FAN</em></p></td>
<td class="td1"><p class="tpara"><em class="italic">Fuerza Aérea Nicaragüense</em> (Nicaraguan Air Force)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">FAO</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Frente Amplio Opositor</em> (Broad Opposition Front)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">FAS</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Fuerza Aérea Sandinista</em> (Sandinista Air Force)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">FER</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Frente Estudiantil Revolucionarío</em> (Revolutionary Student Front)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">FPN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Frente Patriotico Nacional</em> (National Patriotic Front)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">FSLN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Frente Sandinista de Liberación Nacional</em> (Sandinista National Liberation Front)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">GN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Guardia Nacional</em> (National Guard)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">GPP</span></p></td>
<td class="td1"><p class="tpara">Guerra Popular Prolongada (Prolonged Popular War)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">JGRN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Junta de Gobierno de Reconstrucción Nacional</em> (Junta of National Reconstruction)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">LAAHS</span></p></td>
<td class="td1"><p class="tpara">Latin American Aviation History Society</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">MNA</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Movimiento Nueva Nicaragua</em> (New Nicaragua Movement)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">MPS</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Milicia Popular Sandinista</em> (Sandinista Popular Militia)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">MPU</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Movimiento Pueblo Unido (United People’s Movement)</em></p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">OAS</span></p></td>
<td class="td1"><p class="tpara">Organization of American States</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">OSN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Oficina de Seguridad Nacional</em> (National Security Office)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">PLI</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Partido Liberal Indepediente</em> (Independent Liberal Party)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">PLN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Partido Liberal Nacionalista</em> (Liberal Nationalist Party)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">PSN</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Partido socialista nicaragüense</em> (Nicaraguan Socialist Party)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">RPG</span></p></td>
<td class="td1"><p class="tpara">Rocket-propelled grenade</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">SAC</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Servicio Anticomunista</em> (Anti-Communist Service)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">TCU</span></p></td>
<td class="td1"><p class="tpara">Tactical Combat Units</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">UDEL</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Unión Democrática de Liberación </em>(Democratic Liberation Union)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">UN</span></p></td>
<td class="td1"><p class="tpara">United Nations</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">UNO</span></p></td>
<td class="td1"><p class="tpara"><em class="italic">Unión Nacional Opositora</em> (National Opposition Union)</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">USMC</span></p></td>
<td class="td1"><p class="tpara">United States Marine Corps</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">US$</span></p></td>
<td class="td1"><p class="tpara">United States Dollar</p></td>
</tr>
<tr>
<td class="td1"><p class="tpara"><span class="bold">USSR</span></p></td>
<td class="td1"><p class="tpara">Union of Soviet Socialist Republics (or ‘Soviet Union’)</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Abbreviation.vue?66f37f4f